module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"modalTitle":"Sua sessão expirou.","modalMessage":"Tente atualizar a página para realizar o pagamento."},"en-US":{"modalTitle":"Your session has expired.","modalMessage":"Try reload the page to finalize the payment."}}')
  delete Component.options._Ctor
}
